module.exports = __webpack_public_path__ + "static/media/Rectangle.561d70f6.png";